import { batchScheduler } from 'batch-promise';
import quickFetch from 'quick-fetch';
import { createBatchedEarlyRequester } from '../../quickFetch/createBatchedEarlyRequester';
import { promisifyEarlyRequest } from '../../quickFetch/promisifyEarlyRequest';
import { checkFLPGate, readFLPGate } from './auth';
import { convertLegacyObject } from './convertLegacyObject';
export const makeCrmObjectBatchUrl = async (objectTypeId, calls) => {
  var _readFLPGate;
  const params = new URLSearchParams({
    allPropertiesFetchMode: 'latest_version',
    includeAllProperties: 'true',
    includeCurrentUserPermissions: 'true',
    includeObjectVersion: 'false',
    flpViewValidation: (_readFLPGate = readFLPGate()) !== null && _readFLPGate !== void 0 ? _readFLPGate : await checkFLPGate()
  });
  for (const {
    objectId
  } of calls) {
    params.append('id', objectId);
  }
  return `/inbounddb-objects/v1/crm-objects/${objectTypeId}/batch?${params.toString()}`;
};
export const extractCrmObject = ({
  response,
  input: {
    objectId
  }
}) => {
  const result = response[objectId];
  if (result == null) {
    throw new Error(`CrmObject not found: ${objectId}`);
  }
  return convertLegacyObject(result);
};
const scheduler = batchScheduler().read().identity(({
  objectTypeId,
  objectId
}) => `${objectTypeId}:${objectId}`).partition(({
  objectTypeId
}) => objectTypeId).execute(async (calls, objectTypeId) => promisifyEarlyRequest({
  url: quickFetch.getApiUrl(await makeCrmObjectBatchUrl(objectTypeId, Object.values(calls))),
  dataType: 'json'
})).extract(extractCrmObject).immediate();
export const {
  request: earlyCrmObject,
  consume: consumeEarlyCrmObject,
  __TEST_ONLY_reset: __TEST_ONLY_abortCrmObjectLiteEarlyScheduler
} = createBatchedEarlyRequester('hs-resources:simpleCrmObject-early', scheduler);